import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { api, apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { GoldButton } from "../components/UI";
import { GoogleSignInButton, OrDivider } from "../components/GoogleSignIn";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { loginWithToken } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      await loginWithToken(data.token);
      const roles = data.user.roles || [];
      if (roles.includes("WSBF_ADMIN") || roles.includes("FEDERATION_ADMIN")) nav("/admin/federation");
      else if (roles.includes("TEAM_OWNER")) nav("/dashboard/owner");
      else nav("/dashboard");
    } catch (e2) {
      setErr(apiErr(e2, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 animate-fade-up">
      <div className="text-center mb-8">
        <Shield className="w-10 h-10 text-[#E5B842] mx-auto" />
        <h1 className="font-heading text-4xl font-black uppercase tracking-tight text-slate-50 mt-3">Member Access</h1>
        <p className="text-slate-400 text-sm mt-1">Sign in to your WSTF credential</p>
      </div>
      <form onSubmit={submit} className="rounded-xl bg-[#0f0f0f] border border-[#2b2512] p-6 space-y-4">
        <GoogleSignInButton testid="login-google-btn" />
        <OrDivider />
        <Input label="Email" type="email" value={email} onChange={setEmail} testid="login-email" />
        <Input label="Password" type="password" value={password} onChange={setPassword} testid="login-password" />
        {err && <div data-testid="login-error" className="text-rose-400 text-sm">{err}</div>}
        <GoldButton type="submit" className="w-full" disabled={busy} data-testid="login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </GoldButton>
        <p className="text-center text-sm text-slate-400">
          No credential yet?{" "}
          <Link to="/register" className="text-[#E5B842] font-semibold">Register</Link>
        </p>
      </form>
    </div>
  );
}

export function Input({ label, type = "text", value, onChange, testid, placeholder }) {
  return (
    <label className="block">
      <span className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-mono">{label}</span>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="mt-1.5 w-full bg-[#000000] border border-[#2b2512] rounded-lg px-3 py-2.5 text-slate-100 focus:outline-none focus:border-[#E5B842]/50"
      />
    </label>
  );
}
